module.exports = __webpack_public_path__ + "static/img/UCT_logo.png";